// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r2-c";
export var backButton = "_r2-4";
export var backIcon = "_r2-5";
export var chevronShortcut = "_r2-6";
export var container = "_r2-1";
export var editor = "_r2-8";
export var editorWrapper = "_r2-7";
export var prefix = "_r2-2";
export var searchIcon = "_r2-3";
export var suffix = "_r2-9";
export var suffixContent = "_r2-a";
export var suffixText = "_r2-b";
export var wrapper = "_r2-0";